import React, { useState } from "react";
import client from "../../lib/api";
import { toast } from "sonner";
import { ChevronDown, ChevronUp, ArrowRightLeft } from "lucide-react";

const DAY = 86400000;
const label = (t) => `${t.instrument} ${t.direction || ""} · ${t.status} · ${t.status === "closed" ? t.net_pips : t.running_pips} pips · ${new Date(t.opened_at).toLocaleString([], { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" })}`;

function MoveSelect({ trade, index, candidates, onMoved }) {
  const move = async (targetId) => {
    if (!targetId) return;
    try {
      const { data } = await client.post(`/vip-trades/${trade.id}/move-update`, { index, target_id: targetId });
      toast.success(data.source_deleted ? "Update moved · duplicate trade removed" : "Update moved");
      onMoved();
    } catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };
  return (
    <select data-testid={`vt-move-${trade.id}-${index}`} value="" onChange={(e) => move(e.target.value)}
      className="ml-auto max-w-[260px] bg-[color:var(--app-bg)] border border-[color:var(--border-subtle)] px-2 py-1 text-xs text-slate-300 focus:border-gold focus:outline-none">
      <option value="">Move to…</option>
      {candidates.map((c) => <option key={c.id} value={c.id} label={label(c)} />)}
    </select>
  );
}

export function TradeUpdates({ trade, trades, onMoved }) {
  const [open, setOpen] = useState(false);
  const ups = trade.updates || [];
  if (!ups.length) return null;
  const t0 = new Date(trade.opened_at).getTime();
  const candidates = trades.filter((c) => c.id !== trade.id && c.instrument === trade.instrument && Math.abs(new Date(c.opened_at).getTime() - t0) <= 3 * DAY);
  return (
    <div className="basis-full">
      <button data-testid={`vt-updates-toggle-${trade.id}`} onClick={() => setOpen(!open)} className="text-[11px] text-slate-500 hover:text-gold flex items-center gap-1 transition-colors duration-200">
        <ArrowRightLeft size={11} />Updates ({ups.length}){open ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
      </button>
      {open && (
        <div className="mt-2 border-l-2 border-gold/40 pl-3 space-y-1.5" data-testid={`vt-updates-${trade.id}`}>
          {ups.map((u, i) => (
            <div key={`${u.at}-${i}`} className="flex flex-wrap items-center gap-2 text-xs">
              <span className="font-mono text-gold w-16">{u.pips != null ? `${u.pips} p` : "—"}</span>
              <span className="text-slate-300 truncate max-w-[420px]">{u.text}</span>
              <span className="text-slate-600">{u.at ? new Date(u.at).toLocaleString([], { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" }) : ""}</span>
              {candidates.length > 0 ? <MoveSelect trade={trade} index={i} candidates={candidates} onMoved={onMoved} /> : <span className="ml-auto text-slate-600">No nearby call</span>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
